import React, { useEffect, useState } from 'react';
import { TabGroup, Tab } from '../TabGroup/TabGroup';
import { css } from '@emotion/css';
import UserWithoutSubscription from '../UserWithoutSubscription';
import UserWithNoActiveOrders from '../UserWithNoActiveOrders';
import getUpcomingOrder from '../../service/upcoming-order-service';
import { useApp } from '../../context/app-context';
import UserWithActiveOrders from '../UserWithActiveOrders/UserWithActiveOrders';
import { NotificationToastsList } from '../NotificationToast/NotificationToast';
import getFutureOrders from '../../service/future-orders-service';
import SecondTabContent from './SecondTabContent';
import Loader from '../../common/Loading/loader';
import Footer from './Footer';
import { ItemsContext } from '../ScheduledItems/ItemsContext';
import { get, has, invoke, isEmpty } from 'lodash';
import editQuantity from '../../service/edit-quantity-service';
import formatString from '../../utils/formatString';
import appLabels from '../../utils/appLabels';
import getSlotsInfo from '../../service/get-slots-service';
import ThirdTabContent from './ThirdTabContent';
import UserMessage from '../../common/UserMessage/UserMessage';
import AppLabels from '../../utils/appLabels';
import { useWebView } from '../../context/web-view-context';
import ViewportProvider from '../../context/view-port-provider';
import { PreferencesContext } from '../Preferences/PreferencesContext';
import updateNextOrderSlots from '../../service/update-next-order-slots-service';
import getAllAvailableSlotsInfo, { AvailableSlotsPayload } from '../../service/get-all-available-slots';
import { SessionContext } from './SessioncContext';
import getAllPreferences from '../../service/all-preferences-service';
import skipItem from '../../service/skip-item-service';
import { TooltipContainer } from '../../common/PopOver/PopOver';
import moment from 'moment';
import { otaManualBootstrapConfiguration } from '../../utils/constants';
import { getProfileInfo } from '../../service/left-navigation-service';

const landingPageStyle = css`
  @media (max-width: 641px) {
    margin: 1rem 0.8rem;
    min-height: 90vh;
  }
`;

const bannerStyle = css`
  margin-top: 1rem;
`;

const ariaLiveRegionStyle = css`
  position: absolute;
  left: -10px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

export function LandingPageMobile(): JSX.Element {
  const [upcomingOrders, setUpcomingOrders] = useState({});
  const [prevUpcomingOrders, setPrevUpcomingOrders] = useState({});
  const [futureOrders, setFutureOrders] = useState({});
  const [slotsInfo, setSlotsInfo] = useState({});
  const [isUserWithoutSubscription, setIsUserWithoutSubscription] = useState<boolean>(false);
  const [isUserWithNoActiveOrder, setIsUserWithNoActiveOrder] = useState(false);
  const [hasRestrictedItems, setHasRestrictedItems] = useState(false);
  const [isApiError, setIsApiError] = useState(false);
  const [isFutureApiError, setIsFutureApiError] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(true);
  const [isFutureApiLoading, setIsFutureApiLoading] = useState(true);
  const currentWebViewContext = useWebView();
  const user = get(currentWebViewContext, 'user');
  const checkUserHasActiveSession = get(currentWebViewContext, 'checkUserHasActiveSession');
  const isLoading = get(currentWebViewContext, 'isLoading');
  const [otaToSnSFrequencyOptions, setOtaToSnSFrequencyOptions] = useState<object[]>([]);
  const paymentFailure = get(upcomingOrders, 'preCheckFailReason') === 'PAYMENT_FAILURE';
  const userOnHold = get(upcomingOrders, 'userStatus') === 'HOLD';
  const fraudUser = get(upcomingOrders, 'userStatus') === 'FRAUD';

  const {
    showToast,
    appData,
    globalBannerMessage,
    setGlobalBannerMessage,
    setFirstTabBannerMessage,
    globalAriaLiveMessage,
  } = useApp();
  const [preferencesData, setPreferencesData] = useState({});

  useEffect(() => {
    if (!isLoading) {
      console.log(new Date().toISOString(), 'Mobile: Upcoming orders request userID', get(user, 'UUID'));
      getUpcomingOrders();

      getPreferences();

      fetchLeftNavMenuV2();

      initializeSnsOneTimeModal();
    }
  }, [isLoading]);

  const initUserInfo = (ucaUserProfile) => {
    console.log('Mobile: User info:', ucaUserProfile);

    const email = get(ucaUserProfile, 'emails.0.text', '');
    const userType = get(ucaUserProfile, 'customerType', '');
    const firstName = get(ucaUserProfile, 'personalInfo.name.firstName', '');

    if (window['AB'] && window['AB']['userInfo']) {
      window['AB'].userInfo.SWY_SHOP_TOKEN = get(user, 'authToken', '');
      window['AB'].userInfo.UUID = get(user, 'UUID', '');
      window['AB'].userInfo.email = get(user, email, '');
      window['AB'].userInfo.customerType = get(user, 'customerType', '');
      window['AB'].userInfo.userType = get(user, userType, 'C');
      window['AB'].userInfo.banner = get(user, 'banner', '');
      window['AB'].userInfo.customerId = get(user, 'customerId', '');
      window['AB'].userInfo.branchId = get(user, 'shopStoreId', '');
      window['AB'].userInfo.firstName = get(user, firstName, '');
      window['AB'].userInfo.expireTime = '2551924800000'; //Note: This is a future date 2050/11/12 23:00 and this value should be aligned with SWY_SHARED_SESSION_INFO cookie expiry time
      window['AB'].userInfo.zipcode = get(user, 'zipcode', '');
      window['AB'].userInfo.clubCard = get(user, 'clubCard', '');
      window['AB'].userInfo.houseId = get(user, 'houseId', '');

      //window['AB'].userInfo.displayableBanner = get(user, 'displayableBanner', 'Safeway');
      //window['AB'].userInfo.siteType = get(user, 'siteType', 'C');
      window['AB'].userInfo.preferenceMode =
        get(upcomingOrders, 'fulfillment.fulfillmentType') === 'DUG' ? 'Dug' : 'DELIVERY';

      /*
      Site used: https://codechi.com/dev-tools/date-to-millisecond-calculators/
      Method: Convert Date to Milliseconds to generate the expireTime value(Date to milliseconds converter)
       */
    }
  };
  const fetchLeftNavMenuV2 = async () => {
    let profileData = {};
    try {
      profileData = await getProfileInfo(appData.environmentVariables, user);

      initUserInfo(get(profileData, 'data', {}));
      console.log('Profile data:', profileData);
    } catch (e: any) {
      console.error('Error fetching profile info:', e.message);
    }
  };

  const initializeSnsOneTimeModal = () => {
    try {
      if (window['appConfigServiceRef'] && window['appConfigServiceRef']['service']) {
        window['appConfigServiceRef']['service'].initManualBootstrap(otaManualBootstrapConfiguration);
      } else {
        console.error('appConfigServiceRef or service is not defined');
      }
    } catch (error) {
      console.error('Failed to initialize PDP, CouponList, Offer Detail Components:', error);
    }
  };

  useEffect(() => {
    if (upcomingOrders) {
      if (!get(upcomingOrders, 'isNewUser') && get(upcomingOrders, 'userWithNoActiveSubscriptions')) {
        setIsUserWithNoActiveOrder(true);
      } else {
        setIsUserWithNoActiveOrder(false);
        setHasRestrictedItems(get(upcomingOrders, 'hasRestrictedItems', false));
      }

      if (
        has(upcomingOrders, 'isNewUser') &&
        get(upcomingOrders, 'isNewUser', '') !== get(prevUpcomingOrders, 'isNewUser', '')
      ) {
        if (get(upcomingOrders, 'isNewUser')) {
          setIsUserWithoutSubscription(true);
        } else {
          setIsUserWithoutSubscription(false);
          getFutureOrderData();
        }
      }

      setPrevUpcomingOrders(upcomingOrders);
    }
  }, [upcomingOrders]);

  useEffect(() => {
    const paymentFailure = get(upcomingOrders, 'preCheckFailReason') === 'PAYMENT_FAILURE';
    const orderStatus: string = `${get(upcomingOrders, 'upcomingOrder.orderStatus')}`;

    if (orderStatus === 'HOLD') {
      setGlobalBannerMessage(AppLabels.PreferenceTab.userOnHoldMessage);
    }

    if (fraudUser) {
      setGlobalBannerMessage(AppLabels.PreferenceTab.fraudBannerMessage);
    }

    if (/(failed)/i.test(orderStatus) && !paymentFailure) {
      setFirstTabBannerMessage(appLabels.UserWithActiveOrders.failedOrderBannerMessage);
    }
  }, [upcomingOrders, fraudUser]);

  useEffect(() => {
    const isPaymentDetailsNotAvailable = !get(preferencesData, 'paymentsDetailsAvailable', false);
    const precheckFailedReason = get(preferencesData, 'preCheckFailedReason');
    if (
      isPaymentDetailsNotAvailable &&
      (precheckFailedReason === null || precheckFailedReason !== 'PAYMENT_FAILURE') &&
      fraudUser === false &&
      !isEmpty(upcomingOrders) &&
      !isEmpty(preferencesData)
    ) {
      setGlobalBannerMessage(AppLabels.PreferenceTab.noPaymentMethodBanner);
    } else if (globalBannerMessage === AppLabels.PreferenceTab.noPaymentMethodBanner && fraudUser !== true) {
      // only hide the banner if it was the same message
      setGlobalBannerMessage('');
    }
  }, [preferencesData, upcomingOrders, globalBannerMessage, fraudUser]);

  const ensureActiveSession = (callback) => {
    const isActiveSession: boolean = invoke(currentWebViewContext, 'checkUserHasActiveSession');
    return isActiveSession ? callback() : null;
  };

  const fetchUpcomingOrders = async (): Promise<void> => {
    const upcomingOrder = await ensureActiveSession(() => getUpcomingOrder(appData.environmentVariables, user));
    setUpcomingOrders(upcomingOrder.data);
    setOtaToSnSFrequencyOptions(get(upcomingOrder, 'data.frequencies', []));
  };

  const getUpcomingOrders = async (): Promise<void> => {
    setIsApiLoading(true);
    try {
      await fetchUpcomingOrders();
    } catch (error) {
      setIsApiError(true);
    } finally {
      setIsApiLoading(false);
    }
  };

  const fetchFutureOrderData = async (): Promise<void> => {
    console.log(new Date().toISOString(), 'Mobile: Future orders request userID', get(user, 'UUID'));
    const futureOrdersResp = await ensureActiveSession(() => getFutureOrders(appData.environmentVariables, user));
    setFutureOrders(futureOrdersResp.data);
  };

  const getFutureOrderData = async (): Promise<void> => {
    setIsFutureApiLoading(true);
    try {
      await fetchFutureOrderData();
    } catch (error) {
      setIsFutureApiError(true);
    } finally {
      setIsFutureApiLoading(false);
    }
  };

  const getPreferences = async (): Promise<any> => {
    const resp = await ensureActiveSession(async () => {
      return get(await getAllPreferences(appData.environmentVariables, user), 'data');
    });

    setPreferencesData(resp);
    return resp;
  };

  const fetchSlotsInfo = async (): Promise<void> => {
    setSlotsInfo({ loading: true });

    try {
      const storeID = get(upcomingOrders, 'storeId', '');

      if (!isEmpty(storeID)) {
        const resp = await ensureActiveSession(() => getSlotsInfo(appData.environmentVariables, user, storeID));
        setSlotsInfo({ data: resp.data, loading: false });
      } else {
        setSlotsInfo({ error: true, loading: false });
      }
    } catch (err) {
      setSlotsInfo({ error: err, loading: false });
    }
  };

  const updateSlotsInfo = async (slotsInfo: any): Promise<any> => {
    const payload = {
      customerId: get(user, 'UUID', ''),
      storeId: get(upcomingOrders, 'storeId', ''),
      guid: get(user, 'customerId', ''),
      nextOrderID: get(upcomingOrders, 'upcomingOrder.snsNextOrderId'),
      transactionId: get(user, 'UUID', ''),
      itemCount: get(upcomingOrders, 'upcomingOrder.numberOfItems'),
      uniqueItemCount: get(upcomingOrders, 'upcomingOrder.orderItems.length'),
      fulfillment: {
        fulfillmentType: get(upcomingOrders, 'fulfillment.fulfillmentType'),
        slot: slotsInfo,
      },
    };

    try {
      const resp = await ensureActiveSession(() => updateNextOrderSlots(appData.environmentVariables, user, payload));

      if (get(resp, 'status') === 200) {
        showToast(
          'info',
          get(
            resp,
            'message',
            formatString(appLabels.SlotPreferences.SLOTS_SUCCESS, {
              startTime: moment(get(slotsInfo, 'slotStartTS'), 'YYYY-MM-DDThh:mm:ss').format('h A'),
              deliveryDate: moment(get(slotsInfo, 'slotStartTS'), 'YYYY-MM-DDThh:mm:ss').format('MMM. D'),
              endTime: moment(get(slotsInfo, 'slotEndTS'), 'YYYY-MM-DDThh:mm:ss').format('h A'),
              deliveryType: get(upcomingOrders, 'fulfillment.fulfillmentType') === 'DUG' ? 'pickup' : 'delivery',
              date: moment(get(upcomingOrders, 'upcomingOrder.orderDate'), 'YYYY-M-D').format('MMM. D'),
            }),
          ),
        );
        return resp;
      } else {
        showToast('error', appLabels.SlotPreferences.AVAILABLE_SLOT_SAVE_ERROR);
        return { error: true };
      }
    } catch (err) {
      showToast('error', appLabels.SlotPreferences.AVAILABLE_SLOT_SAVE_ERROR);
      return { error: true };
    }
  };

  const fetchAvailableSlotsInfo = async (payload: AvailableSlotsPayload) => {
    return ensureActiveSession(() => getAllAvailableSlotsInfo(appData.environmentVariables, user, payload));
  };

  const ItemUpdateQuantityFn = async (props) => {
    const q = get(props, 'quantity');
    const maxQuantity = get(props, 'maxQuantity');
    const newQuantity = [1, maxQuantity, +q].sort((a, b) => a - b)[1];

    const resp = await ensureActiveSession(() =>
      editQuantity(appData.environmentVariables, user, {
        nextOrderId: get(props, 'nextOrderId'),
        nextOrderItemId: get(props, 'nextOrderItemId'),
        subscriptionId: get(props, 'subscriptionId'),
        isReplinishItem: get(props, 'isReplinishItem'),
        itemBpn: get(props, 'itemBpn'),
        cartId: get(props, 'cartId'),
        quantity: newQuantity,
      }),
    );

    showToast(
      'info',
      formatString(appLabels.QuantitySelector.updatedText, {
        itemDescription: get(props, 'item.itemDescription'),
      }),
    );

    if (get(resp, 'data.statusCode') === 200) {
      await fetchUpcomingOrders();
    }
  };

  const skipItemOnce = async (itemInfo) => {
    await ensureActiveSession(() => skipItem(appData.environmentVariables, user, itemInfo));
  };

  if (isLoading) {
    return (
      <div className={landingPageStyle}>
        <Loader />
      </div>
    );
  }

  return (
    <SessionContext.Provider
      value={{
        user,
        checkUserHasActiveSession,
        ensureActiveSession,
      }}
    >
      <ViewportProvider data-testid="viewport-provider-mobile">
        <div className={landingPageStyle}>
          {isUserWithoutSubscription ? (
            <UserWithoutSubscription />
          ) : (
            <div>
              <NotificationToastsList />
              <TooltipContainer />
              <div aria-live="polite" className={ariaLiveRegionStyle}>
                {globalAriaLiveMessage}
              </div>

              {!isEmpty(globalBannerMessage) ? (
                <UserMessage className={bannerStyle} messageText={globalBannerMessage} messageType="warning" />
              ) : null}

              <TabGroup isLoading={isApiLoading} paymentFailure={paymentFailure}>
                <Tab header="Upcoming orders" disabled={(!isApiLoading && userOnHold) || fraudUser}>
                  <PreferencesContext.Provider
                    value={{
                      fetchSlotsInfo,
                      slotsInfo,
                      updateSlotsInfo,
                      fetchAvailableSlotsInfo,
                    }}
                  >
                    <ItemsContext.Provider
                      value={{
                        updateQuantityFn: ItemUpdateQuantityFn,
                        fetchItemsInfo: async () => {
                          if (has(upcomingOrders, 'isNewUser')) {
                            if (get(upcomingOrders, 'isNewUser')) {
                              fetchUpcomingOrders();
                            } else {
                              fetchUpcomingOrders();
                              fetchFutureOrderData();
                            }
                          }
                        },
                        fetchUpcomingOrdersInfo: async () => {
                          fetchUpcomingOrders();
                        },
                        skipItemOnce,
                        otaToSnsFrequencyOptions: otaToSnSFrequencyOptions,
                      }}
                    >
                      {isUserWithNoActiveOrder ? (
                        <UserWithNoActiveOrders />
                      ) : (
                        <UserWithActiveOrders
                          upcomingOrders={upcomingOrders}
                          futureOrders={futureOrders}
                          isApiError={isApiError}
                          isFutureApiError={isFutureApiError}
                          isApiLoading={isApiLoading}
                          isFutureApiLoading={isFutureApiLoading}
                          hasRestrictedItems={hasRestrictedItems}
                          preferencesData={preferencesData}
                        />
                      )}
                    </ItemsContext.Provider>
                  </PreferencesContext.Provider>
                </Tab>
                <Tab header="Scheduled items" disabled={(!isApiLoading && userOnHold) || fraudUser}>
                  <SecondTabContent upcomingOrders={upcomingOrders} />
                </Tab>
                <Tab header="Preferences">
                  <ThirdTabContent
                    getPreferences={() => getPreferences()}
                    getUpcomingOrders={() => fetchUpcomingOrders()}
                    preferencesData={preferencesData}
                    upcomingOrders={upcomingOrders}
                  />
                </Tab>
              </TabGroup>
            </div>
          )}

          {!isUserWithoutSubscription ? <Footer analyticsState={isUserWithNoActiveOrder} /> : null}
        </div>
      </ViewportProvider>
    </SessionContext.Provider>
  );
}

export default LandingPageMobile;
